<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.materialAbnormalStatus === 'Y'
              ? 'success'
              : row.materialAbnormalStatus === 'S'
              ? 'warning'
              : row.materialAbnormalStatus === 'D' ||
                row.materialAbnormalStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_materialAbnormalStatus }}
        </el-tag>
      </template>
      <template v-slot:processingStatus="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="row.processingStatus === 'Y' ? 'success' : 'info'"
          >
            {{ row.v_processingStatus }}
          </el-tag>
        </div>
        <div v-if="row.actualDate">
          <span>
            {{ $l('table_label_actualDate') || '实际处理日期' }}：{{
              row.actualDate || ''
            }}
          </span>
        </div>
        <div v-if="row.processingStatus == 'Y' && row.processingRemark">
          <span
            style="
            color: #f56c6c;
            border-bottom: 1px solid;
            font-size: 12px;
            cursor: pointer;
          "
            @click.stop="openRemark(row.processingRemark)"
            >{{
              $l('table_label_view_processingRemark') || '查看业务处理说明'
            }}</span
          >
        </div>
      </template>
      <template v-slot:confirmStatus="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="row.confirmStatus === 'Y' ? 'success' : 'info'"
          >
            {{ row.v_confirmStatus }}
          </el-tag>
        </div>
        <div v-if="row.finConfirmDate">
          <span>
            {{ $l('table_label_finConfirmDate') || '确认日期' }}：{{
              row.finConfirmDate || ''
            }}
          </span>
        </div>
        <div v-if="row.confirmStatus == 'Y' && row.confirmRemark">
          <span
            style="
            color: #f56c6c;
            border-bottom: 1px solid;
            font-size: 12px;
            cursor: pointer;
          "
            @click.stop="openConfirmRemark(row.confirmRemark)"
            >{{
              $l('table_label_view_confirmRemark') || '查看财务确认说明'
            }}</span
          >
        </div>
      </template>
      <template v-slot:showAmount="{ row }">
        <span> {{ row.v_currencyAmount }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:createByName="{ row }">
        <span>
          {{ row.createByName }}
        </span>
        <br />
        <span>
          {{ row.createTime }}
        </span>
      </template>
      <template v-slot:modifyByName="{ row }">
        <span>
          {{ row.modifyByName }}
        </span>
        <br />
        <span>
          {{ row.modifyTime }}
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                v-show="opt.show == undefined ? true : opt.show(row)"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      v-if="confirmVisible"
      :title="$l('dialog_label_businessProcessing') || '业务处理'"
      :show-close="true"
      :visible.sync="confirmVisible"
      width="500px"
      :close-on-click-modal="false"
      :before-close="() => cancel()"
    >
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        style="margin-top: 10px; margin-bottom: 10px"
        size="mini"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_actualDate') || '实际处理日期'"
              prop="actualDate"
            >
              <el-date-picker
                v-model="formData.actualDate"
                :placeholder="
                  $l('tip_label_actualDate') || '请选择实际处理日期'
                "
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_processingRemark') || '处理说明'"
              prop="processingRemark"
            >
              <el-input
                v-model="formData.processingRemark"
                :placeholder="
                  $l('tip_label_processingRemark') || '请输入处理说明...'
                "
                type="textarea"
                :autosize="{ minRows: 4 }"
                :maxlength="500"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" @click="save" size="small">{{
          $l('btn_confirm_processing') || '确认处理'
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="rejectReasonVisible"
      width="500px"
      v-if="rejectReasonVisible"
      :before-close="closeRemark"
      v-el-dialog-drag
    >
      <div style="white-space: pre-line">{{ rejectReason }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="closeRemark">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
import validate from '@/libs/util.validate'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this),
      formData: {},
      confirmVisible: false,
      materialAbnormalCode: '',
      rules: {
        actualDate: [
          {
            required: true,
            message: this.$l('tip_label_actualDate') || '请选择实际处理日期...',
            trigger: 'change'
          }
        ],
        processingRemark: [
          {
            required: true,
            message:
              this.$l('tip_label_processingRemark') || '请输入处理说明...',
            trigger: 'blur'
          }
        ]
      },
      rejectReasonVisible: false
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    }
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { materialAbnormalCode, materialAbnormalNo } = data
      const params = { code: materialAbnormalCode }
      const query = { materialAbnormalNo: materialAbnormalNo }
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.openEditPage({
            pageType: menuType,
            params: params,
            query: query
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'rejected':
          this.rejected(data)
          break
        case 'approval':
          this.oaAudit(data)
          break
        case 'confirmProcess':
          this.materialAbnormalCode = materialAbnormalCode
          this.confirmVisible = true
          break
        case 'copy':
          this.copy(data)
          break
      }
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'personal-userMaterialAbnormal-detail',
        params: { ...params, pageType },
        query
      })
    },
    del({ materialAbnormalCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .materialAbnormalDelApi({ materialAbnormalCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success'
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    rejected({ materialAbnormalCode }) {
      this.$confirm(
        this.$l('INDEX.tips_question_reject') || '是否驳回该审核请求？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .materialAbnormalRejectedApi({ materialAbnormalCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.tips_rejected_successfully') || '驳回成功！',
              type: 'success'
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('INDEX.tips_reject_failed') || '驳回失败！'
            )
          })
      })
    },
    async oaAudit({ materialAbnormalCode }) {
      let title = this.$l('INDEX.tips_submit_review') || '是否提交审核？'

      this.$confirm(title, this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText:
          this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning'
      }).then(async () => {
        this.loadingOpen()
        await this.$api
          .materialAbnormalCheckApi({ materialAbnormalCode })
          .then(async () => {
            const linkUrl = this.$joinURL(
              `/opview/userMaterialAbnormal/${materialAbnormalCode}`,
              {
                joinOrigin: true,
                joinBasePath: false
              }
            )
            await this.$api
              .materialAbnormalSubmitOaApplyApi({
                materialAbnormalCode,
                linkUrl
              })
              .then(async () => {
                this.loadingClose()
                this.$message({
                  showClose: true,
                  message:
                    this.$l('INDEX.tips_Submitted_successfully') ||
                    '提交成功！',
                  type: 'success'
                })
                this.$emit('reload')
              })
              .catch(() => {
                this.loadingClose()
                this.$message.error(
                  this.$l('INDEX.tips_submission_failed') || '提交失败！'
                )
              })
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    copy({ materialAbnormalCode }) {
      this.$confirm(
        this.$l('tips_copy_confirm') || '是否复制该单据？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .materialAbnormalCopyApi({ materialAbnormalCode })
          .then((res) => {
            this.loadingClose()
            this.$message.success(this.$l('tips_copy_success') || '复制成功！')
            const params = { code: res.body.materialAbnormalCode }
            const query = { materialAbnormalNo: res.body.materialAbnormalNo }

            // 复制单据后，刷新表格数据
            this.$emit('reload')

            // 复制单据后，跳转到编辑页面
            this.openEditPage({
              pageType: 'edit',
              params: params,
              query: query
            })
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('tips_copy_failed') || '复制失败！')
          })
      })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.loadingOpen()
      this.$api
        .materialAbnormalBusinessProcessingApi({
          ...this.formData,
          materialAbnormalCode: this.materialAbnormalCode
        })
        .then(() => {
          this.loadingClose()
          this.cancel()
          this.$message.success(this.$l('tips_confirm_success') || '处理成功!')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      this.confirmVisible = false
      this.materialAbnormalCode = ''
      this.$refs['form'].resetFields()
    },
    openRemark(msg) {
      this.rejectReason = msg
      this.rejectReasonVisible = true
      this.title = '业务处理说明'
    },
    openConfirmRemark(msg) {
      this.rejectReason = msg
      this.rejectReasonVisible = true
      this.title = '财务确认说明'
    },
    closeRemark() {
      this.rejectReasonVisible = false
      this.title = ''
    }
  }
}
</script>
